<template>
  <div class="invite-experience-rule-component">
    <div class="invite-experience-rule-tag"
         @click="handleClickTag"
    >
      邀请规则
    </div>

    <center-popup class="invite-experience-rule-popup"
                  :show.sync="showPopup"
                  title="邀请规则"
                  size="large"
    >
      <div class="invite-experience-rule-popup-content"
           v-html="rule"
      ></div>
    </center-popup>
  </div>
</template>

<script>
  import CenterPopup from '@/components/CenterPopup';

  export default {
    name: 'MyVipInviteExperienceRule',
    components: {
      CenterPopup,
    },
    props: {
      rule: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        showPopup: false,
      };
    },
    methods: {
      handleClickTag() {
        this.showPopup = true;
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .invite-experience-rule {

    @rule-tag-height: 50px;
    &-tag {
      position: absolute;
      top: 344px;
      right: 0;
      height: @rule-tag-height;
      z-index: @z-index-medium;
      padding: 0 @size-base;
      color: @color-text-light;
      font-size: @font-size-small;
      line-height: @rule-tag-height;
      background: @color-white;
      border-radius: @border-radius-medium 0 0 @border-radius-medium;
      box-shadow: 0 5px 10px 0 rgba(51, 51, 51, 0.05);
    }

    &-popup {
      &-content {
        padding: @size-base @size-medium @size-large;
        text-align: left;
        font-size: @font-size-base;
        color: @color-text-light;
        line-height: 1.8;
      }
    }
  }
</style>
